import { Inject, Injectable, Output, EventEmitter } from '@angular/core';
import { Headers, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { AdalService } from '../shared/azure-authentication/adal.service';
import { BaseEndpoint } from '../app.constants';
import { Configuration } from './configuration.model';
import { UserService } from '../users/user.service';
import { User } from '../users/user.model';
import { forEach } from '@angular/router/src/utils/collection';

@Injectable()
export class ConfigurationService {
    public currentConfiguration: Configuration;
    public currentUser: User;
    @Output() configurationsUpdated: EventEmitter<Configuration[]> = new EventEmitter<Configuration[]>();

    constructor(private http: Http, @Inject(BaseEndpoint) private baseApiUrl: string, private adalService: AdalService, private userService: UserService) {
        this.currentUser = userService.currentUser;
    }

    getConfigurations(): Promise<Configuration[]> {
        const url = this.baseApiUrl + 'v1/configurations/';
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                return resp.json().body as Configuration[];
            })
            .catch(this.handleError);
    }

    getTotalUnderwriterCapacity(): Promise<number> {
        const url = this.baseApiUrl + 'v1/totalunderwriter';
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                return resp.json().body as number;
            })
            .catch(this.handleError);
    }

    updateConfigurations(configs: Configuration[]) {
        for (let config of configs) {
            config.loggedInUserEmail = this.currentUser.email;
        }
        const url = this.baseApiUrl + 'v1/configurations/update';
        return this.http
            .put(url, JSON.stringify(configs), { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                const editConfigurations = resp.json().body as Configuration[];
                this.configurationsUpdated.emit(editConfigurations);
                return editConfigurations;
            })
            .catch(resp => {
                var errors = resp.json().messages;
                if (errors)
                    return this.handleError(errors.map(({ description }) => description));
                else
                    return this.handleError(null);
            });
    }

    private handleError(errors: string[]): Promise<any> {
        console.error('An error occurred', errors);
        return Promise.reject(errors);
    }

}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/configuration/configuration.service.ts